import DotsSingle from './dots.levels'
import DotsPair from './dotsPair.levels'
import Numbers from './numbers.levels'
import NumberLines from './numberLines.levels'
import NumberBridge from './numberBridge.levels'
import NumberLinesBridge from './numberLinesBridge.levels'
import Cherry from './cherry.levels'
import BarModel from './barModel.levels'
import BeadStringSingle from './beadStringSingle.levels'
import BeadStringPair from './beadStringPair.levels'
import TenFrame from './tenFrame.levels'
import HundredSquareTap from './hundredSquareTap.levels'
import NumberWords from './numberWords.levels'
import NumbersCommutativity from './numbersCommutativity.levels'
import HundredSquare from './hundredSquare.levels'
import ValueBlocks from './valueBlocks.levels'
import TenBoards from './tenBoards.levels'
import Sticks from './sticks.levels'
import NumberTracks from './numberTracks.levels'
import BiDirectionalBoxes from './biDirectionalBoxes.levels' 
import Challenge from './challenge.levels' 
import NumbersThree from './numbersThree.levels'
import NumberBond from './numberBond.levels'

export default {
    DotsSingle,
    DotsPair,
    Numbers,
    NumberLines,
    NumberBridge,
    NumberLinesBridge,
    Cherry,
    BarModel,
    BeadStringSingle,
    BeadStringPair,
    TenFrame,
    NumberWords,
    NumbersCommutativity,
    HundredSquare,
    HundredSquareTap,
    ValueBlocks,
    TenBoards,
    Sticks,
    NumberTracks,
    BiDirectionalBoxes,
    Challenge,
    NumbersThree,
    NumberBond,
}
    


// WEBPACK FOOTER //
// ./src/components/game/levels/index.js